import { render, staticRenderFns } from "./EsCol.vue?vue&type=template&id=15cee32a"
import script from "./EsCol.vue?vue&type=script&lang=js"
export * from "./EsCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports